export const DEFAULT_ENTITY_CRITICALITY = 'Default';
